import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';

export const useRedirectToChatroom = () => {
  const navigate = useNavigate();

  return useCallback(
    async (chatroomId: string) => {
      await navigate(routes.chat.chatroom(chatroomId), { replace: true });
    },
    [navigate],
  );
};
